import Guid from "_shared/guids/guid";

export default class SystemNotification {
  public readonly id: Guid;
  public readonly content: string;

  public get message(): string {
    if (!this.content.includes(':')) return this.content;
    return this.content.split(':').filter(Boolean)[1];
  }

  public get type(): string | undefined {
    return this.content.split(':').find(Boolean);
  }

  public constructor(id: Guid, content: string) {
    this.id = id;
    this.content = content;
  }
}
